import { graphql } from "gatsby";
import React from "react";

import RequestForm from "../components/forms/requestForm";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { ThemeContext } from "../context/ThemeContext";
import heroImgPlaceholder from "../images/volunteer/hero-img.png";
import {
  preFilterGroupPrograms,
  preFilterStandardPrograms
} from "../utils/base";

export default function EnquiryForm(props) {
  const { data, location } = props;
  const page = data?.page;
  const acfLandingPage = page?.acfLandingPage;
  const genericDetails = data?.genericDetails;

  const heroBackgroundImage =
    page?.globalConfig &&
    page?.globalConfig?.backgroundImage &&
    page?.globalConfig?.backgroundImage?.localFile &&
    page?.globalConfig?.backgroundImage?.localFile?.extension
      ? page?.globalConfig.backgroundImage.localFile.publicURL
      : page?.globalConfig &&
          page?.globalConfig?.backgroundImage &&
          page?.globalConfig?.backgroundImage?.sourceUrl
        ? page?.globalConfig?.backgroundImage?.sourceUrl
        : heroImgPlaceholder;

  const groupProgramSourceType =
    acfLandingPage?.genProgramListSourceType === "group_programs";

  const defaultStandardPrograms =
    data?.programs?.nodes?.filter((program) =>
      preFilterStandardPrograms(program)
    ) ?? [];

  const defaultGroupPrograms =
    data?.groupPrograms?.nodes
      ?.filter((grpProgram) => preFilterGroupPrograms(grpProgram))
      ?.map((grpProgram) => ({
        ...grpProgram,
        uri: grpProgram?.uri?.replace(
          "group-travel-single",
          "group-travel/schools"
        )
      })) ?? [];

  const defaultPrograms = groupProgramSourceType
    ? defaultGroupPrograms
    : defaultStandardPrograms;

  // console.debug("location", !location.search?.includes("consultation"));

  const budgetPricing =
    genericDetails?.acfOptionsIngoProgramsConfig?.priceBudgetRangeFilters;

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page?.title ?? ""}
          containerClass={"w-full mx-auto enquiry-form sm:pb-32 sm:pt-20"}
          brandingOpts={{ ...theme }}
          updateOnScroll={false}
        >
          <RequestForm
            page={page}
            currentUrl={location?.href}
            programs={defaultPrograms}
            backImage={heroBackgroundImage}
            calendlyActive={true}
            budgetPricing={budgetPricing}
          />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
}

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query {
    page: wpPage(slug: { eq: "enquiry-form" }) {
      ...WpPageFragment
    }

    genericDetails: wp {
      acfOptionsIngoProgramsConfig {
        priceBudgetRangeFilters {
          budgetPricing {
            budgetPricingIsoCode
            budgetPricingOptions {
              budgetPricingOptionsLabel
              budgetPricingOptionsMax
              budgetPricingOptionsMin
            }
          }
        }
      }
    }

    groupPrograms: allWpGroupProgram {
      nodes {
        ...groupProgramMiniDataFilterableFragment
      }
    }

    programs: allWpProgram(
      # filter: { acfProgramsMeta: { programIngo: { ne: true } } }
      # filter: { acfProgramsMeta: { programJourneys: { ne: true } } }
      sort: { acfProgramsMeta: { programRating: DESC } }
    ) {
      nodes {
        ...programMiniDataFilterableFragment
      }
    }
  }
`;
